import React from 'react';

const Politica = () => {
  return (
    <div className="max-w-6xl mx-auto p-4 md:p-6 lg:p-8">
      <h1 className="text-3xl font-bold mb-4">Política de Privacidad</h1>
      <p className="text-lg mb-4">
        En Store Computer, nos comprometemos a proteger la privacidad de nuestros usuarios. Esta política de privacidad describe cómo recopilamos, utilizamos y protegemos la información personal de nuestros usuarios.
      </p>
      <h2 className="text-2xl font-bold mb-2">Recopilación de información</h2>
      <p className="text-lg mb-4">
        No recopilamos ningún dato personal de nuestros usuarios. Nuestra aplicación se ejecuta en los Servidores en la nube de Railway y Netlify, lo que significa que los datos de nuestros usuarios no están sujetos a ninguna de sus las políticas de privacidad.
      </p>
      <h2 className="text-2xl font-bold mb-2">Uso de la información</h2>
      <p className="text-lg mb-4">
        No utilizamos la información personal de nuestros usuarios para ningún propósito.
      </p>
      <h2 className="text-2xl font-bold mb-2">Seguridad de la información</h2>
      <p className="text-lg mb-4">
        Nos esforzamos por proteger la seguridad de la información personal de nuestros usuarios. Nuestra aplicación utiliza las medidas de seguridad proporcionadas porRailway y Netlify para proteger los datos de nuestros usuarios.
      </p>
      <h2 className="text-2xl font-bold mb-2">Cambios en la política de privacidad</h2>
      <p className="text-lg mb-4">
        Podemos actualizar esta política de privacidad en cualquier momento. Los cambios entrarán en vigor inmediatamente después de su publicación en nuestra aplicación.
      </p>
      <h2 className="text-2xl font-bold mb-2">Contacto</h2>
      <p className="text-lg mb-4">
        Si tienes alguna pregunta o inquietud sobre nuestra política de privacidad, por favor no dudes en contactarnos.
      </p>
    </div>
  );
};

export default Politica;